import { Percent } from "@mui/icons-material";
import {
  Box,
  Button,
  CardContent,
  Grid,
  Tooltip,
  Typography,
  useTheme,
} from "@mui/material";
import { Stack } from "@mui/system";
import { IconArrowRight, IconCoinRupee } from "@tabler/icons";
import { useEffect, useState } from "react";
import { LineWave } from "react-loader-spinner";
import { useNavigate, useParams } from "react-router-dom";
import { axiosInstance } from "src/api/axios";
import BlankCard from "../../../components/shared/BlankCard";

const ProductGrid = () => {
  const [product, setProduct] = useState([]);
  let { category } = useParams();
  const theme = useTheme();
  const [productImages, setProductImages] = useState([]);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  useEffect(() => {
    axiosInstance.get("/product").then((response) => {
      console.log(response.data);
      if (response.data && response.data.length) {
        setLoading(false);
        if (category) {
          if (category === "others") {
            category = "hot projects";
          }
          let filtered_products = response.data.filter((items) =>
            items.category.toLowerCase().includes(category.toLowerCase())
          );
          setProduct(filtered_products);
          let images = filtered_products.map((data, index) => {
            if (data.images.length) {
              return data.images[0];
            }
          });
          setProductImages(images);
        } else {
          setProduct(response.data);
          let images = response.data.map((data, index) => {
            if (data.images.length) {
              return data.images[0];
            }
          });
          setProductImages(images);
        }
      }
    });
  }, [category]);

  return (
    <Grid container spacing={3}>
      {loading ? (
        <Grid container>
          <Grid item xs={12}>
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              height={"60vh"}
            >
              <LineWave height={545} width={250} style={{ margin: "auto" }} />
            </Stack>
          </Grid>
        </Grid>
      ) : product.length ? (
        product.map((product, index) =>
          product.images.length ? (
            <Grid item xs={12} sm={6} key={index} sx={{ minWidth: "400px" }}>
              <Typography
                onClick={() => {
                  navigate(`/products/${product.id}`);
                }}
              >
                <BlankCard>
                  <CardContent
                    sx={{ p: 2, maxHeight: "270px", minHeight: "270px" }}
                  >
                    <Grid container xs={12} spacing={1}>
                      <Grid item xs={12}>
                        <Stack direction={"row"} justifyContent={"flex-end"}>
                          <Box
                            sx={{
                              p: 1.2,
                              borderRadius: 2,
                              opacity: 0.7,
                              fontWeight: 700,
                              bgcolor:
                                (product?.status === "Active"
                                  ? theme.palette.earnpati.active
                                  : theme.palette.earnpati.paused) ||
                                theme.palette.earnpati.active,
                              color:
                                product?.status === "Active"
                                  ? "#008000"
                                  : "#D50000",
                            }}
                          >
                            {product.status || "Active"}
                          </Box>
                        </Stack>
                      </Grid>
                      <Grid item xs={5}>
                        <Tooltip title={`Grab Offer for ${product.title}`}>
                          <img
                            src={productImages[index]}
                            alt="img"
                            width="100%"
                            style={{
                              height: "100%",
                              minHeight: "100px",
                              minWidth: "100px",
                            }}
                          />
                        </Tooltip>
                      </Grid>
                      <Grid
                        container
                        xs={7}
                        sx={{ pt: 2, pl: 1.5 }}
                        spacing={0.5}
                      >
                        <Grid item>
                          <Typography variant="h5">{product.title}</Typography>
                        </Grid>
                        <Grid item xs={12}>
                          <Typography
                            sx={{
                              whiteSpace: "nowrap",
                              textOverflow: "ellipsis",
                              width: "105%",
                              overflow: "hidden",
                            }}
                          >
                            {product.info}
                          </Typography>
                        </Grid>
                        <Grid item>
                          <Typography
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              fontWeight: 700,
                              fontSize: "16px",
                            }}
                          >
                            {product.earntype || "Earn Upto"}:
                            {!product?.isPercentage ? (
                              <>
                                <IconCoinRupee />
                                <span>{product.earnUpto}</span>
                              </>
                            ) : (
                              <>
                                <span>{product.earnUpto}</span>
                                <Percent style={{ width: "24px" }} />
                              </>
                            )}
                          </Typography>
                        </Grid>

                        <Grid item xs={12}>
                          <Button
                            sx={{
                              bgcolor: theme.palette.earnpati.main,
                              width: "100%",
                              "&:hover": {
                                backgroundColor: theme.palette.earnpati.success,
                                cursor: "pointer",
                              },
                            }}
                            variant="contained"
                            size="medium"
                          >
                            View Details <IconArrowRight />
                          </Button>
                        </Grid>
                      </Grid>
                    </Grid>
                  </CardContent>
                </BlankCard>
              </Typography>
            </Grid>
          ) : null
        )
      ) : (
        <h3 style={{ margin: "auto", padding: "100px" }}>
          Seems like All Offers are paused in this category.
        </h3>
      )}
    </Grid>
  );
};

export default ProductGrid;
